// Empty state for a Standup bucket (Needs You, Drafts Ready, Follow-ups, Auto-handled).
// Uses the same warm editorial tone as the populated states.

type EmptyBucketProps = {
  headline: string; // may contain italic accent words wrapped in <em> via the prop
  body: string;
};

export function EmptyBucket({ headline, body }: EmptyBucketProps) {
  return (
    <div className="empty-card">
      <h3 dangerouslySetInnerHTML={{ __html: headline }} />
      <p>{body}</p>
    </div>
  );
}
